import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";

// Services
import clientesService from "@services/clientes";
import postosService from "@services/postos";

import { MdPrint } from "react-icons/md";
import AutoComplete from "@components/AutoComplete";
import ReactTable from "@components/ReactTable";
import PDFPrint from "@components/PdfPrint";
import ClipLoader from "react-spinners/ClipLoader";

// Components
import EmpresaSelect from "@components/EmpresaSelect";
import Menu from "@components/Menu";
import DateRangePicker from "@components/DateRangePicker";

import { threeDecimal } from "@utils/format";

import UserContext from "@components/context/userContext";

class Page extends Component {
  static contextType = UserContext;

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      table: {
        columns: [
            {
                Header: "Cliente",
                accessor: "cliente",
            },
            {
                Header: "Talão",
                id: "talao",
                accessor: (d) => `${d.posto}${d.tpv}${d.serie}/${d.talao}`,
              },
              {
                Header: "Data",
                accessor: "data",
              },
              {
                Header: "C.Produto",
                accessor: "produto",
              },
              {
                Header: "Produto",
                accessor: "designacao",
              },
              {
                Header: "Qtd",
                accessor: "qnt",
              },
              {
                Header: "Valor",
                accessor: "total",
              },
              {
                Header: "Matricula",
                id: "matricula",
                accessor: (d) => d.matricula || d.codigo_matricula,
              },
              {
                Header: "Km Ant.",
                id: "kilometros_anteriores",
                accessor: (d) => d.kilometros_anteriores > 0 ? d.kilometros_anteriores : '',
              },
              {
                Header: "Km Atuais",
                id: "kilometros_actuais",
                accessor: (d) => d.kilometros_actuais > 0 ? d.kilometros_actuais : '',
              },
              {
                Header: "Média",
                id: "media",
                accessor: (d) => {
                  if (d.kilometros_actuais > 0 && d.kilometros_anteriores > 0 && d.qnt > 0) {
                    const kilometros_actuais = parseFloat(d.kilometros_actuais);
                    const kilometros_anteriores = parseFloat(d.kilometros_anteriores);
                    const qnt = parseFloat(d.qnt);
                    return ((kilometros_actuais - kilometros_anteriores) / qnt).toFixed(1);
                  }
                  return '';
                },
              },
        ],
        rows: [],
        loading: false,
      },
      posto: {
        value: "",
        label: "TODOS",
      },
      cliente: {
        value: "",
        label: "TODOS",
      },
      pagamento: {
        value: "",
        label: "TODOS",
      },
      pagamentos: [{
            value: "",
            label: "TODOS",
        },
        {
            value: "1",
            label: "Dinheiro"
        },
        {
            value: "2",
            label: "Crédito"
        },
        {
            value: "3",
            label: "Cheque"
        },
        {
            value: "4",
            label: "TPA"
        },
        {
            value: "8",
            label: "Frota"
        },
        {
            value: "14",
            label: "Serviços Internos"
        },
        {
            value: "101",
            label: "Dinheiro"
        },
        {
            value: "102",
            label: "TPA"
        },
        {
            value: "103",
            label: "Cheque"
        },
        {
            value: "104",
            label: "Transferência"
        }],
      date: [(new Date()).setHours(0 , 0 , 0) , (new Date()).setHours (23 , 59 , 59)],
      isSubmiting: false,
      previewUrl: null,
    };
    this.printerRef = React.createRef();
    this.loadFunction = this.loadFunction.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.localDateChange = this.localDateChange.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
  }

  async loadFunction() {
    if (!this.state.loaded) {
        const profile = this.context;

        try {
            const postos = await postosService.get(profile.idEmpresaSec);
            const enrichedPostos = postos.map((posto) => ({ value: posto.posto, label: posto.nome }));
            this.setState({ postos: [{ value: '', label: 'TODOS' },...enrichedPostos] });
            
            const clientes = await clientesService.get(profile.idEmpresaSec);
            const enrichedClientes = clientes.map((cliente) => ({ value: cliente.codigo, label: cliente.nome_1 }));
            this.setState({ clientes: [{ value: '', label: 'TODOS' },...enrichedClientes], loaded: true });
        } catch (error) {
            console.error(error);
        }
    }
  }

  async getConsumption() {
    const profile = this.context;
    const { date } = this.state;

    try {
        const consumption = await clientesService.getConsumption(
            profile.idEmpresaSec,
            this.state.cliente.value,
            this.state.posto.value,
            (date[0]/1000).toString().split('.')[0],
            (date[1]/1000).toString().split('.')[0],
            this.state.pagamento.value !== '' ? this.state.pagamento.value : undefined
        );
        
        this.setState({
            table: {
              ...this.state.table,
              rows: consumption,
              loading: false,
            },
            loaded: true,
        });
    } catch (error) {
        console.error(error);
    }
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
      [name]: value,
    }, () => {
        switch (name) {
            case "posto":
            case "cliente":
            case "pagamento":
                this.setState({
                    table: {
                        ...this.state.table,
                        loading: true,
                    }
                    })
                this.getConsumption()
                break;
            default:
                break;
            }
    });
  }

  localDateChange(date) {
    this.setState({ date: [
        date[0].setHours(0 , 0 , 0),
        date[1].setHours(23 , 59 , 59),
      ]
    }, () => {
            this.setState({
              table: {
                ...this.state.table,
                loading: true,
              }
            })
            this.getConsumption()
    });
  }

  async handlePrint() {
    const profile = this.context;
    const { date, cliente, posto, pagamento } = this.state;
    
    this.setState({ isSubmiting: true });
    
    const startdate = (date[0]/1000).toString().split('.')[0];
    const enddate = (date[1]/1000).toString().split('.')[0];
    
    await this.setState({ 
      previewUrl: `https://eposgestofinal.com/api/clientes/consumption/pdf.php?idempresa=${profile.idEmpresaSec}&cliente=${cliente.value}&posto=${posto.value}&startdate=${startdate}&enddate=${enddate}&pagamento=${pagamento.value}`
    });
    
    // eslint-disable-next-line no-unused-expressions
    this.printerRef.current?.handlePrint().then(() => {
      this.setState({ isSubmiting: false });
    });
  }

  render() {
    const { table, posto, postos, cliente, clientes, date, pagamento, pagamentos } = this.state;
    const { location, history } = this.props;
    const cookies = new URLSearchParams(location.search);

    return (
      <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: "left",
                marginTop: "75px",
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li className="active">Consumos</li>
            </ol>
          </div>
        </div>
        <EmpresaSelect />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-sm-12" style={{ textAlign: "center" }}>
            <div className="panel panel-default" style={{ minHeight: '700px' }}>
              <div
                className="panel-heading"
                style={{
                  fontWeight: "bold",
                  fontSize: "15pt",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: '15px'
                }}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  Consumos
                </div>
              </div>
              <table className="table table-bordered table-hover table-sortable">
                <thead>
                  <tr>
                    <th className="text-center">Data</th>
                    <th className="text-center">Cliente</th>
                    <th className="text-center">Posto</th>
                    <th className="text-center">Pagamento</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ width: "200px" }}>
                      <DateRangePicker maxDate={new Date()} value={date} onChange={this.localDateChange} />
                    </td>
                    <td>
                      <AutoComplete
                        name={"cliente"}
                        value={cliente}
                        handleChange={this.handleChange}
                        options={clientes}
                      />
                    </td>
                    <td style={{ width: "200px" }}>
                      <AutoComplete
                        name={"posto"}
                        value={posto}
                        handleChange={this.handleChange}
                        options={postos}
                      />
                    </td>
                    <td style={{ width: "200px" }}>
                        <AutoComplete
                        name={"pagamento"}
                        value={pagamento}
                        handleChange={this.handleChange}
                        options={pagamentos}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <table style={{ marginBottom: 0 }} className="table table-bordered-only-inside">
                  <tbody>
                      <tr>
                          <td style={{ fontWeight: 'bolder', verticalAlign: 'middle', textAlign: 'right' }}>
                            <button 
                              className="btn btn-primary" 
                              onClick={this.handlePrint}
                              disabled={this.state.isSubmiting}
                            >
                              {this.state.isSubmiting ? <ClipLoader size={15} color="#fff" /> : <><MdPrint size={18} /> Imprimir relatório</>}
                            </button>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <table style={{ marginBottom: 0 }} className="table">
                  <tbody>
                      <tr>
                          <td  style={{ fontWeight: 'bolder', verticalAlign: 'middle', textAlign: 'right' }}>
                          Total
                          <h4>{table.rows.length > 0 ? threeDecimal(table.rows.reduce((acc, row) => acc + parseFloat(row.qnt), 0)) : 0}</h4>
                          </td>
                      </tr>
                  </tbody>
              </table>
              <ReactTable
                columns={table.columns}
                sortable={true}
                loading={table.loading}
                data={table.rows}
                excelDownload={true}
              />
            </div>
          </div>
        </div>
        <PDFPrint ref={this.printerRef} pdfUrl={this.state.previewUrl} />
      </div>
    );
  }
}

export default withCookies(withRouter(Page));
